import * as React from 'react';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { debounce } from 'throttle-debounce';
import { clsx } from 'clsx';

import * as style from './NextButton.css';
import { TABLE_SCROLL_BUTTON_DELAY } from '../../constants/delays';

export interface INextButtonProps {
  last: boolean;
  sticky: boolean;
  onClick: () => void;
}

export const NextButton = ({ last, onClick, sticky }: INextButtonProps): React.JSX.Element | null => {
  // oxlint-disable-next-line react/exhaustive-deps
  const debouncedHandleClick = React.useCallback(debounce(TABLE_SCROLL_BUTTON_DELAY, onClick), [onClick]);

  if (last) {
    return null;
  }

  return (
    <div onClick={debouncedHandleClick} className={clsx(style['container'], sticky && style['container--sticky'])}>
      <IconActionChevronRight16 color={'icon-inverted-default'} />
    </div>
  );
};
